import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {GestureConfig, MatDatepickerIntl} from '@angular/material';
import {SDKBrowserModule, UserProfileApi} from './shared/services/sdk';
import {ToastrModule} from 'ngx-toastr';

import {rootRouterConfig} from './app.routing';
import {SharedModule} from './shared/shared.module';
import {AppComponent} from './app.component';

import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {EqualValidatorDirective} from './directives/equal-validator.directive';
import {NgxPermissionsModule} from 'ngx-permissions';
import {NgxUploaderModule} from 'ngx-uploader';
import {FlexLayoutModule} from '@angular/flex-layout';


// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

@NgModule({
    imports: [
        BrowserModule,
        NgxUploaderModule,
        BrowserAnimationsModule,
        SharedModule,
        HttpClientModule,
        FlexLayoutModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        RouterModule.forRoot(rootRouterConfig, {useHash: false}),
        SDKBrowserModule.forRoot(),
        ToastrModule.forRoot(),
        NgxPermissionsModule.forRoot()
    ],
    exports: [RouterModule],
    declarations: [AppComponent, EqualValidatorDirective],
    providers: [
        // ANGULAR MATERIAL SLIDER FIX
        {provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig},
        MatDatepickerIntl,
        UserProfileApi
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
